<div class="timeline-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading timeline...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="errorMessage && !isLoading" class="error-state">
    <div class="error-icon">⚠️</div>
    <h2>Error</h2>
    <p>{{ errorMessage }}</p>
    <button class="btn btn-primary" (click)="goBack()">Go Back</button>
  </div>

  <!-- Timeline Content -->
  <div *ngIf="timeline && !isLoading" class="timeline-content">
    <!-- Header -->
    <div class="timeline-header">
      <button class="back-btn" (click)="goBack()" title="Go back">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Back</span>
      </button>
      <h1>Life Timeline</h1>
      <h2 class="relative-name">{{ timeline.relativeName }}</h2>
    </div>

    <!-- Timeline -->
    <div class="timeline-wrapper">
      <div class="timeline-line"></div>
      
      <div class="timeline-events" *ngIf="timeline.events.length > 0">
        <div 
          *ngFor="let event of timeline.events; let i = index" 
          class="timeline-event"
          [style.--event-color]="getEventColor(event.eventType)">
          <div class="event-marker">
            <div class="event-icon">{{ getEventIcon(event.eventType) }}</div>
          </div>
          
          <div class="event-content">
            <div class="event-card">
              <div class="event-header">
                <h3 class="event-title">{{ event.title || event.eventType }}</h3>
                <span class="event-date">{{ formatDate(event.eventDate) }}</span>
              </div>
              
              <div class="event-body">
                <p class="event-description" *ngIf="event.description">
                  {{ event.description }}
                </p>
                
                <div class="event-details">
                  <div class="event-type-badge" [style.background-color]="getEventColor(event.eventType)">
                    {{ event.eventType }}
                  </div>
                  
                  <div class="event-location" *ngIf="event.location">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" stroke-width="2"/>
                      <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/>
                    </svg>
                    {{ event.location }}
                  </div>
                  
                  <div class="event-related" *ngIf="event.relatedRelativeName">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    {{ event.relatedRelativeName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="no-events" *ngIf="timeline.events.length === 0">
        <p>No timeline events available for this relative.</p>
      </div>
    </div>
  </div>
</div>

